import Vue from 'vue'
import './plugins/axios'
import './plugins/toasted'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DateFilter from './filters/date'

Vue.config.productionTip = false
Vue.filter('date', DateFilter)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
